import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";

const PROGRAMS_IMAGE =
  "https://customer-assets.emergentagent.com/job_muscle-builder-268/artifacts/baicx74r_IMG_3651.jpeg";

const FEATURES = [
  "Fully personalised training program",
  "Custom nutrition & macro targets",
  "Weekly check-ins & plan adjustments",
  "Direct messaging access to Amani",
  "Plateau-breaking progression strategy",
  "Form reviews & technique coaching",
];

export const Programs = ({ onApply }) => {
  return (
    <section
      id="programs"
      data-testid="programs-section"
      className="py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#E63946]" />
              <span className="text-xs uppercase tracking-[0.3em] text-neutral-400">
                Coaching
              </span>
            </div>
            <h2 className="font-heading font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              1-on-1 Online Coaching
            </h2>
            <p className="mt-5 text-neutral-300 text-base lg:text-lg leading-relaxed max-w-lg">
              Premium, hands-on coaching built entirely around you. This isn't a
              cookie-cutter PDF — it's a partnership focused on accountability and
              real results.
            </p>

            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {FEATURES.map((f) => (
                <li
                  key={f}
                  className="flex items-start gap-3 text-neutral-200 text-sm"
                >
                  <span className="mt-0.5 h-5 w-5 flex-shrink-0 flex items-center justify-center bg-[#E63946]">
                    <Check size={14} />
                  </span>
                  {f}
                </li>
              ))}
            </ul>

            <button
              onClick={onApply}
              data-testid="programs-cta"
              className="group mt-10 inline-flex items-center gap-2 bg-[#E63946] hover:bg-[#D90429] text-white font-heading font-bold uppercase tracking-wide text-base px-8 py-4 transition-all hover:scale-[1.03]"
            >
              Start Your Transformation
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <img
              src={PROGRAMS_IMAGE}
              alt="Amani Lubembe at the gym"
              className="w-full h-[420px] lg:h-[500px] object-contain bg-[#0A0A0A]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            <div className="absolute bottom-0 left-0 p-8">
              <p className="font-heading text-2xl font-black uppercase tracking-tight">
                No Plateaus.
                <br />
                <span className="text-[#E63946]">Only Progress.</span>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
